module.exports = __webpack_public_path__ + "img/selected0-min.e7c1e4b8.png";